import { render, staticRenderFns } from "./FjLogin.vue?vue&type=template&id=27b1351e&scoped=true&"
import script from "./FjLogin.vue?vue&type=script&lang=js&"
export * from "./FjLogin.vue?vue&type=script&lang=js&"
import style0 from "./FjLogin.vue?vue&type=style&index=0&id=27b1351e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1351e",
  null
  
)

export default component.exports